import { useRef } from "react";
import { TableRowWrapper } from "./styled";
import PropTypes from "prop-types";
import Tooltip from "../Tooltip/Tooltip";

const TableRow = ({
  row,
  rowIndex,
  customCellProps,
  onRowClick,
  cellRefs,
  isRecentlyCreated,
  isSelected,
  disabled,
  getTooltipMessage
}) => {
  const rowRef = useRef(null);

  const tooltipLabelText = getTooltipMessage ? getTooltipMessage(row.original) : null;
  return (
    <>
      <TableRowWrapper
        ref={rowRef}
        {...row.getRowProps()}
        onClick={() => {
          onRowClick != undefined && onRowClick(row?.original);
        }}
        isRecentlyCreated={isRecentlyCreated}
        isSelected={isSelected}
        disabled={disabled}>
        {row.cells.map((cell, index) => {
          return (
            <td
              key={index}
              {...cell.getCellProps()}
              ref={(ref) => (rowIndex === 0 ? (cellRefs.current[index] = ref) : null)}>
              {cell.render("Cell", customCellProps)}
            </td>
          );
        })}

        {onRowClick && tooltipLabelText && (
          <Tooltip childrenRef={rowRef} tooltipLabel={tooltipLabelText} />
        )}
      </TableRowWrapper>
    </>
  );
};

TableRow.propTypes = {
  row: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  customCellProps: PropTypes.object,
  onRowClick: PropTypes.func,
  cellRefs: PropTypes.object,
  isRecentlyCreated: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  getTooltipMessage: PropTypes.func,
  disabled: PropTypes.bool,
};

export default TableRow;
